<mat-card-header>
    <mat-toolbar class="toolbar">
      <mat-card-title style="font-size: 20px; font-weight: bold; font-family: 'Times New Roman', Times, serif;">{{ 'freeticketcard' | translate }} </mat-card-title>
      <span class="toolbar-spacer"></span>
      <button mat-mini-fab (click)="close()" color="primary" title="{{ 'back' | translate }} " ><mat-icon>cancel</mat-icon></button>

      <!-- <mat-icon (click)="addagence()">add</mat-icon> -->
      <ng-container *ngIf="card?.length == 10 && userprivileges[90].state">
        <a (click)="generatecode()" mat-raised-button>{{
          "buttons.generate" | translate
        }}</a>
      </ng-container>
    </mat-toolbar>
  </mat-card-header>

  <br/>
<div class="container">
  <!-- table display content here-->
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

         <!-- ID Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> No. </th>
          <td mat-cell *matCellDef="let element; let i=index;"> {{i+1}} </td>
        </ng-container>

           <!-- Name Column -->
          <ng-container matColumnDef="ticket">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'ticket' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row?.idpvDisplay || row?.idpv}} </td>
         </ng-container>

           <!-- Name Column -->
          <ng-container matColumnDef="passager">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'passager' | translate}} </th>
              <td mat-cell *matCellDef="let row"> {{row?.passager?.nompassager}} </td>
          </ng-container>

          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'table_headers.phone' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.passager?.contact}} </td>
          </ng-container>

          <ng-container matColumnDef="destination">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'destination' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.destination?.nomdest}} </td>
          </ng-container>

          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'category' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row?.voyage?.category.nomcategory}} </td>
          </ng-container>

          <ng-container matColumnDef="bus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'table_headers.bus' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row?.voyage?.busname==null?row.voyage.nomvoyage:row.voyage.busname}} </td>
          </ng-container>
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'Date ENRG' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.passager?.creationdate}} </td>
          </ng-container>

          <ng-container matColumnDef="tarif">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'table_headers.tarif' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row?.voyage?.tarif.tarif}} </td>
          </ng-container>

          <ng-container matColumnDef="siege">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'siege' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row?.place}} </td>
          </ng-container>

          <ng-container matColumnDef="createdby">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'createdby' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row?.createdby}} </td>
        </ng-container>

        <ng-container matColumnDef="datecreation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'Date ENRG' | translate}} </th>
          <td mat-cell *matCellDef="let row"> {{row.creationdatetime | date:"dd-MM-yyyy HH:mm:ss"}} </td>
        </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'action' | translate}} </th>
        <td mat-cell *matCellDef="let element">
            <!-- <ng-container *ngIf="isNumber(element?.freeticketcode) && element?.montant > 0 && element?.place > 0"> -->
              <!-- <mat-checkbox [checked]="mymodel" (change)="remove(element)"></mat-checkbox> -->
              <button mat-mini-fab (click)="remove(element)" color="primary" title="{{ 'remove' | translate }} " ><mat-icon>cancel</mat-icon></button>
            <!-- </ng-container> -->
        </td>
    </ng-container>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        No records found.
      </td>
    </tr>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"  ></tr>
        <!-- <tr  mat-row *matRowDef="let row; columns: displayedColumns;"></tr> -->
        <tr class="example-element-row" mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="row.place == 0? {'highlight2': row.place==0}:{'highlight1': row.transferfrom!= null}"></tr>

    </table>

    <mat-paginator [pageSize]="10" [pageSizeOptions]="[0,card?.length]" (page)="nextPage($event)" [length]="card?.length"
    showFirstLastButtons></mat-paginator>
  </div>
  <div  fxLayout="row-reverse" fxLayoutGap="10px">
    <!-- <button
      mat-raised-button
      cdkFocusInitial
      color="primary" tabindex="2"
      [disabled]="fiscaliteform.invalid"
    >
    <span *ngIf="!(loading$ | async)">{{
      "buttons.save" | translate
    }}</span>
    <mat-spinner
      color="accent"
      class="mat-spinner-white mx-auto"
      *ngIf="loading$ | async"
      [diameter]="33"
    >
    </mat-spinner>
    </button> -->
    <a (click)="empty()" mat-raised-button>{{
      "buttons.clean" | translate
    }}</a>
  </div>
</div>

